import React from "react";

import {
  Tooltip,
  TooltipProps,
  Avatar,
  AvatarProps,
  Flex,
  Text,
} from "@chakra-ui/react";

export type AvatarWithTooltipProps = {
  tooltipProps: Omit<TooltipProps, "children">;
  avatarProps: AvatarProps;
};

export default function AvatarWithTooltip({
  tooltipProps,
  avatarProps,
}: AvatarWithTooltipProps) {
  return (
    <Tooltip {...tooltipProps}>
      <Avatar {...avatarProps} />
    </Tooltip>
  );
}

export type UserAvatarWithRoleProps = {
  src: string;
  name: string;
  role: string;
  rootProps?: Partial<AvatarWithTooltipProps>;
};

export function UserAvatarWithRole({
  src,
  name,
  role,
  rootProps,
}: UserAvatarWithRoleProps) {
  return (
    <AvatarWithTooltip
      avatarProps={{
        src,
        name,
        ...(rootProps?.avatarProps || {}),
      }}
      tooltipProps={{
        bgColor: "brand",
        p: "2",
        fontSize: "sm",
        label: (
          <Flex direction="column" alignItems="center">
            <Text color="white" fontWeight="semibold">
              {name}
            </Text>
            <Text color="white">{role}</Text>
          </Flex>
        ),
        ...(rootProps?.tooltipProps || {}),
      }}
    />
  );
}
